import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import axiosInstance from "../../../utils/axiosConfig";

function Parallax() {
  const [offset, setOffset] = useState(0);
  const [landingImage, setLandingImage] = useState(null);

  useEffect(() => {
    const fetchLandingImage = async () => {
      try {
        const response = await axiosInstance.get("/landing_options");
        if (response.data && response.data.length > 0) {
          setLandingImage(response.data.filter(x => x.key === "landing_image")[0].image_url);
        }
      } catch (error) {
        console.error("Error fetching landing image:", error);
      }
    };

    fetchLandingImage();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => {
        setOffset(window.pageYOffset);
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        height: "150vh",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: landingImage ? `url(${landingImage})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          transform: `translateY(${offset * 0.3}px)`,
        }}
      />
      <Box
        sx={{
          position: "relative",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#FFC107",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Ingeniería a tu servicio
        </Typography>
        <Typography
          variant="h4"
          sx={{
            mb: 4,
          }}
        >
          Somos un grupo humano apasionado por la ingeniería electrónica y
          mecánica.
        </Typography>
      </Box>
    </Box>
  );
}

export default Parallax;
